module.exports = __webpack_public_path__ + "fonts/nucleo-icons.woff2!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.woff2
// module id = 109
// module chunks = 0